import { cva } from 'cva';
import type { LinkProps as RACLinkProps } from 'react-aria-components/Link';
import { Link as RACLink } from 'react-aria-components/Link';

import styles from './link.module.css';

export const linkVariants = cva({
  base: styles.link,
  variants: {
    color: {
      inherit: styles.color_inherit,
      default: styles.color_default,
    },
  },
  defaultVariants: {
    color: 'default',
  },
});

export type LinkProps = RACLinkProps & {
  color?: 'default' | 'inherit';
};

/**
 * A link allows a user to navigate to another page or resource within a web page or application.
 *
 * See `LinkButton` for a link that looks like a button.
 *
 * See https://react-spectrum.adobe.com/react-aria/Link.html for more details.
 *
 * ```tsx
 * <Link href="/home">
 *    Go to home
 * </Link>
 * ```
 */
export const Link = ({ color, className, ...props }: LinkProps) => {
  const classes = linkVariants({ color, className });
  return <RACLink {...props} className={classes} />;
};
